// extracted by mini-css-extract-plugin
export default {"container":"order-detail_container__ysO3e","isLoading":"order-detail_isLoading__LBBjW","orderIdStyle":"order-detail_orderIdStyle__DDhkH"};